module.exports = __webpack_public_path__ + "static/media/80000.db55394c.png";